module.exports = __webpack_public_path__ + "img/408-d9e24a.png";